export default "/static/1803de7d3a4fe6d7.png"